import React, { useEffect, useState } from 'react'
import carParking from "../../assets/images/car-parking.png";
import paymentImg from "../../assets/images/payment.png";
import gpsImg from "../../assets/images/car.png";
import qrImg from "../../assets/images/qr-code-scan.png";
import rechargeImg from "../../assets/images/recharge.png";
import pollutionImg from "../../assets/images/pollution.png";
import challanImg from "../../assets/images/gavel.png";
import logo from '../../assets/images/logo.png'
import insuranceImg from "../../assets/images/clipboard.png";
import { useNavigate } from 'react-router-dom';
import { Header } from "antd/lib/layout/layout";
import { Button, Drawer, Row } from 'antd';
import { MenuOutlined } from '@ant-design/icons';

const LandingHeader = () => {
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 786);
    const [drawerVisible, setDrawerVisible] = useState(false);

    const handleResize = () => {
        setIsMobile(window.innerWidth <= 1024);
    };

    const user = JSON.parse(localStorage.getItem("user"));

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const services = [
        { img: paymentImg, label: "Pay Bills", route: "/user/bill-pay" },
        { img: rechargeImg, label: "Recharge", route: "/user/recharge" },
        { img: carParking, label: "Parking", route: "/user/parking" },
        { img: gpsImg, label: "Buy GPS", route: "/user/buy-gps" },
        { img: qrImg, label: "Get QR Code", route: "/user/get-qr" },
        { img: pollutionImg, label: "PUC Check", route: "/user/puc-check" },
        { img: challanImg, label: "Check Challans", route: "/user/check-challan" },
        { img: insuranceImg, label: "Insurance", route: '/user/insurance' },
    ];

    return (
        <Header 
            style={{
                position: "sticky",
                top: 0,
                zIndex: 1000,
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "white",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "45px 30px",
            }}
        >
            {/* Left: Logo */}
            <div style={{ display: "flex", alignItems: "center" }} className='header-logo' onClick={() => navigate('/')}>
                <img width={140} src={logo} alt="Logo" />
            </div>

            {/* Center: Service Icons or Burger Menu */}
            {!isMobile ? (
                <Row
                    gutter={[16, 16]}
                    style={{
                        flex: 1,
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                    }}
                >
                    {services.map((service, index) => (
                        <div
                            key={index}
                            onClick={() => navigate(service.route)}
                            style={{
                                textAlign: "center",
                                margin: "0 15px",
                                cursor: "pointer",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}
                        >
                            <div className="top-bar-icon-wrapper">
                                <img
                                    src={service.img}
                                    alt={service.label}
                                    className="service-icon"
                                    // style={{ width: 40, height: 40 }}
                                />
                            </div>
                            {/* <div style={{ marginTop: 5, fontSize: 12 }}>{service.label}</div> */}
                        </div>
                    ))}
                </Row>
            ) : (
                <MenuOutlined
                    style={{ fontSize: 24, cursor: "pointer", margin: '20px'}}
                    onClick={() => setDrawerVisible(true)}
                />
            )}

            {/* Right: Sign-In Button */}
            <Button
                type="primary"
                size="large"
                onClick={() => navigate(user ? '/user/home' : "/sign-in")}
                className="form-btn"
            >
                {user ? user.name : 'Sign In'}
            </Button>

            {/* Drawer for Mobile View */}
            <Drawer
                title="Services"
                placement="right"
                onClose={() => setDrawerVisible(false)}
                open={drawerVisible}
            >
                {services.map((service, index) => (
                    <div
                        key={index}
                        onClick={() => {
                            navigate(service.route);
                            setDrawerVisible(false); // Close drawer after navigation
                        }}
                        style={{
                            marginBottom: 20,
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <img
                            src={service.img}
                            alt={service.label}
                            style={{ width: 40, height: 40, marginRight: 20 }}
                        />
                        <span style={{fontSize: 15}}>{service.label}</span>
                    </div>
                ))}
            </Drawer>
        </Header>
    )
}

export default LandingHeader